import React, { Component } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import { TableComp } from 'sz-react-utils'
import moment from 'moment/moment'
import _ from 'lodash'
import ListFollowUps from '../../../../components/_utils/listFollowUp'
import {
    Avatar,
    Button,
    Card,
    Checkbox,
    notification,
    Select,
    Tooltip,
    Col,
    DatePicker,
    Row,
    Input,
    Switch,
    Drawer,
    Icon, Form, Popover,
    Popconfirm,
    Progress,
    Tag,
    Divider,
    Dropdown,
    Menu,
    Badge
} from "antd";
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL, MEDIA_URL } from '../../../../request'
import { HiInformationCircle } from "react-icons/hi";
import { FaWhatsapp } from "react-icons/fa";
import { connect } from 'react-redux'

import styles from './styles.less'
import common from '../../../common.less'
import LatestFollowUp from '../../../../components/_utils/latestFollowup'
import Settings from '../../../../components/_utils/settings'
import RecentInvoices from '../../../../components/_utils/recentInvoices'
import Payment from '../../../../components/_utils/payment'
import CompanyDetails from '../../../../components/Invoice/companyDetails';
import SelectedStudentInvoices from '../../../../components/Invoice/selectedStudentInvoices';
import lodash from 'lodash'

import SMS from '../../../../components/communication/sms'
import WhatsAPPSMS from '../../../../components/communication/WhatsAppSms'
import EmailDrawer from '../../../../components/communication/emailDrawer'
import InvoiceUploadForm from '../../../../components/Invoice/invoiceUploadForm'
import EnrollmentDrawer from '../claimProcessing/enrollmentDrawer'
import InquiryReviewDrawer from '../../../../components/drawers/inquiryReviewDrawer'
import BranchInvoiceApprovalDrawer from '../../../../components/drawers/branchInvoiceApprovalDrawer'
import { RightsWrapper } from '../../../../components/_utils/utils'
import ClaimDeskStats from '../../../../components/stats/claimDeskStats'

var reviewStatusOptions = [
    { value: 'Under Review', text: 'Under Review' },
    { value: 'Verified', text: 'Verified' },
    { value: 'Max Commission Received', text: 'Max Commission Received' }
];
const COLORS = ["#16a34a", "#ea580c", "#2563eb", "#7c3aed", "#d97706", "#059669", "#2563eb", "#4f46e5", "#c026d3", "#e11d48"];

let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let companyDetails = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : {};
let studentObj = {};
let userCheckBox = {}
let counsellingData = {}
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
const Option = Select.Option
let inquiryObj = {}
const { Search } = Input
const { RangePicker, MonthPicker } = DatePicker



@Form.create()
class MultipleFollowUpDrawer extends Component {
    state = {
        visible: true,
        followUpObject: []
    }


    loadFollowUpTypes = async () => {
        let params = {
            results: 10000,
            count: 10000
        }
        let response = await Request.getFollowUpTypes(params)
        let followUpObject = []
        _.each(response.data, (followUp) => {
            followUpObject.push({ id: followUp.name, display: followUp.name })
        })
        this.setState({ followUpObject })
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose();
        }, 50)
    }

    componentDidMount() {
        this.loadFollowUpTypes()
    }


    handleSubmit = async (e) => {
        let { counsellingData, form } = this.props;
        e.preventDefault();
        form.validateFields(async (err, valData) => {
            let values = _.clone(valData);
            values.usersData = counsellingData.usersData;
            let response = await Request.addMultipleFollowUps(values);
            if (response.success) {
                notification.success({
                    message: response.message
                })

            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose();
        })
    }


    render() {



        let { form: { getFieldDecorator } } = this.props;
        const inputTypes = {
            fields: [
                {
                    label: 'Next Follow Up Date',
                    key: 'date',
                    type: 'date',
                    required: true
                },
                {
                    label: 'Details',
                    key: 'detail',
                    type: 'textArea',
                    rows: 10,
                    required: true
                },
                {
                    label: 'FollowUp Out Come',
                    key: 'followUpType',
                    type: 'select',
                    required: true,
                    options: this.state.followUpObject,
                    placeholder: 'Select followUp Type',
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            followUpType: v
                        })
                    }
                },
            ]
        }
        return (
            <Drawer
                title={
                    <div>
                        <Icon type={'calendar'} />
                        NEW FOLLOW UP
                    </div>
                }
                width={500}
                closable={false}
                onClose={this.onClose}
                visible={this.state.visible}>
                <div>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                    {/* <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                {inputTypes.map((itype, key) => {
                    return (
                <div key={key}>
                <GetAllFormFields
                inputSchema={inputTypes[key]}
                getFieldDecorator={getFieldDecorator}
                />
                </div>
                )
                })}
                
                <Row>
                <Col span={8}/>
                <Col span={8}>
                <Button
                type="primary"
                htmlType="submit"
                style={{marginBottom: 10}}
                loading={this.props.loading}>
                SAVE
                </Button>
                </Col>
                <Col span={8}/>
                </Row>
                </Form> */}
                </div>
            </Drawer>
        )
    }

}

class ClaimDesk extends Component {
    state = {
        search_keyword: '',
        count: 0,
        followDuesCount: 0,
        showFollowUp: false,
        showRecentInvoices: false,
        studentId: null,
        studentSearchId: '',
        allBranches: [],
        counsellorId: '',
        counsellors: [],
        recentInvoices: [],
        channelPartnerList: [],
        selectMultipleRecords: [],
        channelPartners: [],
        showCompanyDetailForm: false,
        universities: [],
        enableBTN: false,
        deskColor: null,
        ratingArr: ['Fit2Apply', 'Potential', 'Luke Warm', 'Cold', 'Dead'],
        leadSourceList: ['University', 'Channel Partner'],
        invoiceStatusList: ['Missing Invoice Dates', 'Term-1', 'Term-2', 'Term-3', 'Term-4', 'Not Enrolled Yet', 'Enrolled Now', 'Ongoing', 'Max Commission Claimed', 'Withdrawn - Bad Debts', 'To Be Invoiced', 'Invoice Processed-Term 1', 'Invoice Processed-Term 2', 'Invoice Processed-Term 3', 'Invoice Processed-Term 4', 'Invoice Processed-Term 5', 'Commission Pending', 'Commission Pending - Term 1', 'Commission Pending - Term 2', 'Commission Pending - Term 3', 'Commission Pending - Term 4', 'Commission Pending - Term 5', 'Invoice Received-Term 1', 'Invoice Received-Term 2',],
        invoiceStatusList2: ["Commission Pending", "Commission Received"],
        termList: ['Term-1', 'Term-2', "Term-3", "Term-4", "Term-5", "Term-6", "Term-7", "Term-8"],
        invoiceStatuses: ['Pending', 'Generated', 'Submitted To Uni', "Approved by Uni", "Paid by Uni", "Cleared"],
        invoiceStatus: '',
        drawerTodayPastInvoices: true,
        paymentBalance: [{ label: 'Not Received', value: true },
        { label: 'Received', value: false }],
        showPayNow: false,
        showUploadDetailForm: false,
        showMultipleFollowupDrawer: false,
        isFollowUpOverdue: false,
        showSMS: false,
        showWhatsAppSms: false,
        showEmail: false,
        userCheckBox: {},
        showSelectedInvoices: false,
        courseStartDate: [],
        selectedDates: [],
        universityInstitutionName: '',
        channelPartnerId: '',
        showEnrollmentDrawer: false,
        studentBranchId: '',
        countries: [],
        showReviewDrawer: false,
        invoiceYear: null,
        inquiryDetail: {},
        showBranchInvoiceDrawer: false,
        invoicesTotal: {
            invoiceTotal: 0,
            performaInvoiceTotal: 0,
            groupedPerformaInvoiceTotal: 0,
            finalInvoiceTotal: 0
        },
        invoicePrefixes: null,
        time: {
            from: '',
            to: ''
        },
        invoiceGenerationDate: {
            from: null,
            to: null
        },
        loading: false,
        branchPlan: null,
        enrollmentStatusArr: [
            { statusName: 'Visa Approved Students', count: 0 },
            { statusName: 'Unenrolled Students', count: 0 },
            { statusName: 'Enrolled Students', count: 0 },
            { statusName: 'Enrollment due', count: 0 }
        ],

        invoiceStatsArr: [
            { statusName: 'Invoices not due yet', count: 0 },
            { statusName: 'Invoices due for generation', count: 0 },
            { statusName: 'Invoices due for Review', count: 0 },
            { statusName: 'Invoices paid not updated', count: 0 }
        ],

        statusStatsArr: [
            { statusName: 'Raised PI Invoices', count: 0, col: 4 },
            { statusName: 'Raised FI Invoices', count: 0, col: 4 },
            { statusName: 'Submitted to Uni', count: 0, col: 4 },
            { statusName: 'Approved by Uni', count: 0, col: 4 },
            { statusName: 'Paid by Uni', count: 0, col: 4 },
            { statusName: 'Cleared', count: 0, col: 4 },
        ]
    }

    getStats = async (filters) => {
        let statsFilters = { ...filters };
        delete statsFilters.enrollmentStat;
        delete statsFilters.invoiceStat;
        delete statsFilters.statusStat;
        delete statsFilters.count;
        delete statsFilters.page;
        statsFilters.atLevel = ["Claim Desk"];

        try {
            let res = await Request.getClaimDeskStats(statsFilters);
            if (res && res.success) {
                this.setState({
                    enrollmentStatusArr: res.enrollmentStatusArr,
                    invoiceStatsArr: res.invoiceStatsArr,
                    statusStatsArr: res.statusStatsArr
                });
            }
        } catch (e) {
            console.error("Error fetching claim desk stats", e);
        }
    }

    loadChannelPartners = async () => {
        let { data: channelPartnerList } = await Request.getSimplePartners({
            results: 10000,
            sortField: 'channelPartnerName',
            sortOrder: 'ascend'
        })
        let channelPartners = channelPartnerList.reduce((temp, vv) => {
            temp.push({ _id: vv._id, display: vv.channelPartnerName })
            return temp
        }, [])

        this.setState({ channelPartners });
        let params = {};
        params.atLevel = ["Claim Desk"];
        params.nextInvoiceGeneration = true;
        let response = await Request.loadCounselling({
            ...params,
        });
        if (response.total > 0) {
            response.data.forEach((item) => {
                if (
                    item.nextInvoiceGenerationDates &&
                    item.nextInvoiceGenerationDates.length > 0
                ) {
                    item.nextInvoiceGenerationDates.forEach((invoiceDate) => {
                        let newObj = {};
                        if (!invoiceDate.invoiceGenerated) {
                            newObj.generationDate = moment(invoiceDate.generationDate).format(
                                "DD-MMM-YYYY"
                            );
                            let dataType = moment(newObj.generationDate).isSame(moment(), 'day')
                                ? "Today"
                                : moment(newObj.generationDate).isBefore()
                                    ? "Overdue"
                                    : "Future";
                            if (dataType === 'Today' || dataType === 'Overdue') {
                                this.setState({ showRecentInvoices: true })
                            }
                        }
                    });
                }
            });
        }
        this.setState({ channelPartnerList })
    }

    closeBranchInvoiceDrawer = () => {
        this.setState({ showBranchInvoiceDrawer: false })
    }

    loadBranchPlan = async () => {
        let response = await Request.getBranchDetails();
        if (response && response.doc && response.doc.planDetails && response.doc.planDetails.planCommission && response.doc.planDetails.planCommissionType) {
            this.setState({ branchPlan: { commission: response.doc.planDetails.planCommission, commissionType: response.doc.planDetails.planCommissionType } });
        }
    }
    loadUserRights = async () => {
        let { userRights } = await Request.loadUserRights()
        let claimDeskRights = userRights.ClaimDesk;
        // if (claimDeskRights && claimDeskRights.viewByBranch) {
        //     this.loadBranchPlan()
        // }
        this.setState({ claimDeskRights: userRights.ClaimDesk })
    }

    removeSelectedIntake = (index) => {
        let { selectedDates, courseStartDate } = this.state;

        selectedDates.splice(index, 1);
        courseStartDate.splice(index, 1);

        this.setState(
            { selectedDates, courseStartDate },
            () => {
                if (this.table && this.table.current) {
                    this.table.current.reload();
                }
            }
        );
    };

    clearSelectedIntakes = () => {
        this.setState(
            {
                selectedDates: [],
                courseStartDate: []
            },
            () => {
                if (this.table && this.table.current) {
                    this.table.current.reload();
                }
            }
        );
    };

    generateAutoPI = async (recordId) => {
        this.setState({ loading: true });
        let response = await Request.generateAutoPI({ id: recordId });
        this.setState({ loading: false });
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.table.current.reload();
    }
    showSMS = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showSMS: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    closeSMS = () => {
        this.setState({ showSMS: false })
    }

    closeReviewDrawer = () => {
        this.setState({ inquiryDetail: {}, showReviewDrawer: false }, () => {
            this.table.current.reload();
        })
    }
    showWhatsAppSms = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return (item.isChecked === true ? item : false);
        })

        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showWhatsAppSms: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }

    changeSearchValue = (value) => {
        this.setState({ search_keyword: value }, () => {
            this.table.current.reload()
        })
    }
    closeWhatsSMS = () => {
        this.setState({ showWhatsAppSms: false })
    }
    closeEmail = () => {
        this.setState({ showEmail: false })
    }

    closeMultipleFollowUp = () => {
        this.setState({ showMultipleFollowupDrawer: false }, () => {
            counsellingData = {};
            userCheckBox = {};
            this.table.current.reload();
        })
    }



    changeStudentEnrollment = async ({ checked, _id }) => {
        await Request.updateStudentEnrollment({ _id, enrolledInUniversity: checked })
        this.table.current.reload()
    }
    showEmail = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showEmail: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    selectUser = (item, studentId) => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)

        if (cloneUserCheckBox[studentId] === undefined) {
            cloneUserCheckBox[studentId] = [];
        }
        cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked;
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    selectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = true
        })
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    unselectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = false
        })
        this.setState({ userCheckBox: cloneUserCheckBox })
    }


    onChangeDatePicker = (date) => {

        if (!date) {
            return;
        }

        let { courseStartDate, selectedDates } = this.state;

        let selectedDate = moment(date).format('YYYY-MMM');

        if (selectedDates.includes(selectedDate)) {

            const index = selectedDates.indexOf(selectedDate);

            if (index > -1) {
                selectedDates.splice(index, 1);
                courseStartDate.splice(index, 1);
            }

        } else {

            courseStartDate.push({
                from: moment(date).startOf('month').format('YYYY-MM-DD'),
                to: moment(date).endOf('month').format('YYYY-MM-DD')
            });

            selectedDates.push(selectedDate);
        }

        this.setState(
            { courseStartDate, selectedDates },
            () => {
                if (this.table && this.table.current) {
                    this.table.current.reload();
                }
            }
        );
    };


    searchByInvoiceYear = (invoiceYear) => {

        if (invoiceYear !== undefined && invoiceYear !== null) {

            const baseYear = moment(`${invoiceYear}-01-01`, 'YYYY-MM-DD');

            this.setState(
                {
                    invoiceGenerationDate: {
                        from: baseYear.clone().startOf('year'),
                        to: baseYear.clone().endOf('year')
                    },
                    invoiceYear
                },
                () => {
                    if (this.table && this.table.current) {
                        this.table.current.reload();
                    }
                }
            );
        } else {
            this.setState(
                {
                    invoiceGenerationDate: { from: null, to: null },
                    invoiceYear: null
                },
                () => {
                    if (this.table && this.table.current) {
                        this.table.current.reload();
                    }
                }
            );
        }
    };



    apiRequest = (params, columns) => {
        return new Promise(async resolve => {
            // params.count = 200
            let { universityInstitutionName, channelPartnerId, studentBranchId, courseStartDate } = this.state
            if (!params.sortField) {
                params.sortField = 'moveDeskDate.moveToClaimDesk'
                params.sortOrder = 'descend'
            }
            if (this.state.search_keyword && this.state.search_keyword !== "") {
                params.keyword = this.state.search_keyword
            }

            if (this.state.counsellorId) {
                params.counsellorId = this.state.counsellorId;
            }
            if (this.state.studentSearchId) {
                params.studentSearchId = this.state.studentSearchId;
            } else {
                params.studentSearchId = '';
            }

            if (this.state.termNumber) {
                params.termNumber = this.state.termNumber
            }

            if (this.state.invoiceStatus) {
                params.invoiceStatus = this.state.invoiceStatus;
            }


            if (this.state.commissionStatus) {
                params.commissionStatus = this.state.commissionStatus;
            }

            if (this.state.reviewStatus) {
                params.invoiceReviewDetails = this.state.reviewStatus;
            }

            if (universityInstitutionName) {
                params["visaDesk.selectedCourse.universityId"] = universityInstitutionName;
            }
            if (channelPartnerId) {
                params["visaDesk.channelPartnerId"] = channelPartnerId;
            }

            if (studentBranchId) {
                params.studentBranchId = studentBranchId;
            }

            if (this.state.enrollmentStat) params.enrollmentStat = this.state.enrollmentStat;
            if (this.state.invoiceStat) params.invoiceStat = this.state.invoiceStat;
            if (this.state.statusStat) params.statusStat = this.state.statusStat;

            // Fetch the stats asynchronously without blocking the table reload
            this.getStats(params);


            if (this.state.courseStartDate) {
                params['courseStartDate'] = courseStartDate;
            }

            if (params.dateOfBirth && params.dateOfBirth.length > 0) {
                var splitDate = params.dateOfBirth[0].split('-');
                const monthNames = ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ];
                var monthName = monthNames[splitDate[1] - 1];

                params.dateOfBirth = splitDate[0] + '-' + monthName + '-' + splitDate[2];

                const stringToDate = new Date(params.dateOfBirth);
                params.dateOfBirth = {
                    $gte: moment(params.dateOfBirth, dateFormat).startOf('day'),
                    $lt: moment(params.dateOfBirth, dateFormat).endOf('day'),
                };
            } else {
                delete params.dateOfBirth
            }

            if (this.state.generationDate) {
                params.generationDate = this.state.generationDate;
            }

            if (this.state.isFollowUpOverdue) {
                params.isFollowUpOverdue = this.state.isFollowUpOverdue;
            }

            if (this.state.invoiceGenerationDate && this.state.invoiceGenerationDate.from && this.state.invoiceGenerationDate.to) {
                params.invoiceGenerationDate = this.state.invoiceGenerationDate;
            }

            params.atLevel = ['Claim Desk']


            let data = await Request.loadCounselling({
                ...params,
                regExFilters: ['studentName', 'email', 'mobile', 'updatedByUser.name', 'createdByUser.name', 'instituteStudentId', 'nextInvoiceGenerationDates.invoiceGeneratedNumber']
            })


            delete data.error
            delete data.type
            userCheckBox = {};
            lodash.each(data.data, (item) => {
                if (!userCheckBox[item._id]) {
                    userCheckBox[item._id] = {
                        _id: item._id,
                        emailId: item.emailId,
                        mobile: item.mobile,
                        studentName: item.studentName,
                        isChecked: false
                    }
                }
            })

            this.setState({ count: data.total, invoicesTotal: data.invoicesTotal, followDuesCount: data.followUpsDuesCount, allBranches: data.allBranches, userCheckBox: userCheckBox })
            resolve(data)
        })
    }

    openPayNow = record => {
        inquiryObj = {
            record: record,
            registrationDesk: record.registrationDesk,
            _id: record._id
        }
        this.setState({ showPayNow: true })
    }

    closePayNow = () => {
        this.setState({ showPayNow: false })
        this.table.current.reload()
    }

    loadUniversity = async () => {
        Request.loadSimpleUniversities({ sort: { instituteName: 1 } })
            .then(resp => {
                resp.arr = resp.arr.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.universityInstitutionName })
                    return temp
                }, [])

                this.setState({ universities: resp.arr });
            })
            .catch(err => {
                console.log(err)
            })
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.loadUniversity();
        this.loadChannelPartners()
        this.loadUserRights()
        this.followUpsCallback = this.followUpsCallback.bind(this);
        Request.getCounsellorsUsers()
            .then(resp => {
                if (resp) {
                    let temp = [{ display: '---Show All---', id: '' }];
                    resp.data = resp.data.reduce((el, vv) => {
                        vv.display = vv.name
                        vv.id = vv._id
                        temp.push(vv)
                        return temp
                    }, []);
                    this.setState({ counsellors: resp.data })
                }
            })
            .catch(err => {
            })
    }

    closeFollowUp = () => {
        this.setState({ showFollowUp: false })
    }
    openFollowUps = record => {
        studentObj = {
            arr: record.followUp,
            name: record.studentName,
            rating: record.counsellingDesk.rating,
            subRating: record.counsellingDesk.subRating,
            _id: record._id
        };
        this.setState({ showFollowUp: true })
    }

    followUpExtendedDate = (followUp) => {
        if (followUp && followUp.followUpDate) {
            return moment(moment(new Date()).format('YYYY-MM-DD[T00:00:00.000Z]')).isAfter(followUp.followUpDate);
        }
    }


    addMultipleFollowUps = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showMultipleFollowupDrawer: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }

    renderStatus = (record) => {
        let val = 'Ongoing';
        if (record.atLevel == 'Operation Manager Desk') {
            val = 'Not Enrolled Yet';
        } else if (record.atLevel == 'Front Desk') {
            val = 'Ongoing';
        } else if (['Registration Desk', 'Application Desk', 'Visa Desk'].includes(record.atLevel)) {
            val = 'Enrolled Now';
        } else if (record.atLevel === 'Claim Desk') {
            val = 'To Be Invoiced';

            const terms = record.nextInvoiceGenerationDates || [];

            if (terms.length > 0) {

                // 🔹 PI generated automatically (PI-TP-*)
                const autoPIGenerated = terms.some(t =>
                    t.invoiceGenerated === true &&
                    typeof t.invoiceGeneratedNumber === 'string' &&
                    t.invoiceGeneratedNumber.includes('PI-TP-')
                );

                if (autoPIGenerated) {
                    val = 'Auto PI Generated';
                } else {

                    const generatedInvoices = record.generatedInvoices || [];

                    const getStatusWeight = (status) => {
                        const s = (status || '').toLowerCase().trim();
                        if (['cleared', 'paid by uni', 'completed'].includes(s)) return 4;
                        if (s === 'approved by uni') return 3;
                        if (s === 'submitted to uni') return 2;
                        if (s === 'generated') return 1;
                        return 0;
                    };

                    const getActualStatus = (t) => {
                        let actualStatus = t.invoiceStatus;
                        if (t.uploaded !== true) {
                            const matchingInvs = generatedInvoices.filter(gi =>
                                gi.invoiceNumber === t.invoiceGeneratedNumber ||
                                (t.cpInvoiceNumber && gi.invoiceNumber === t.cpInvoiceNumber)
                            );
                            const foundInvoice = matchingInvs.length > 0 ? matchingInvs[matchingInvs.length - 1] : null;
                            if (foundInvoice && foundInvoice.invoiceStatus) {
                                const genStatus = foundInvoice.invoiceStatus;
                                const dbWeight = getStatusWeight(actualStatus);
                                const genWeight = getStatusWeight(genStatus);
                                actualStatus = dbWeight >= genWeight ? actualStatus : genStatus;
                            }
                        }
                        return actualStatus;
                    };

                    const clearedInvoices = terms.filter(t => {
                        if (t.invoiceGenerated !== true || !t.invoiceGeneratedNumber) return false;
                        const actualStatus = getActualStatus(t);
                        return actualStatus === 'Cleared' || actualStatus === 'Paid by Uni' || actualStatus === 'Paid By Uni' || actualStatus === 'Completed';
                    });

                    const pendingInvoices = terms.filter(t => {
                        if (t.invoiceGenerated !== true || !t.invoiceGeneratedNumber) return false;
                        const actualStatus = getActualStatus(t);
                        return !(actualStatus === 'Cleared' || actualStatus === 'Paid by Uni' || actualStatus === 'Paid By Uni' || actualStatus === 'Completed');
                    });

                    const processedCount = clearedInvoices.length;

                    if (pendingInvoices.length > 0) {
                        val = 'Commission Pending - Term ' + (processedCount + 1);
                    } else if (processedCount > 0) {
                        if (processedCount === terms.length) {
                            val = 'Max Commission Paid';
                        } else {
                            val = 'Invoice Processed-Term ' + processedCount;
                        }
                    }
                }
            }
        }

        else if (record.atLevel == 'Archive Desk') {
            val = 'Max Commission Paid';
        } else if (['Dead Inquiry', 'Deleted'].includes(record.atLevel)) {
            val = 'Withdrawn - Bad Debts';
        }

        if (val === 'Ongoing' || val === 'Invoice Processed-Term 1' || val === 'Enrolled Now') {
            return <div className={styles.Ongoing}>{val === "Invoice Processed-Term 1" ? "Commission Received-Term 1" : val}</div>
        }
        if (val === 'Not Enrolled Yet' || val === 'Invoice Processed-Term 4') {
            return <div className={styles.notEnrolled}>{val === "Invoice Processed-Term 4" ? "Commission Received-Term 4" : val}</div>
        }

        if (val === 'Max Commission Paid' || val === 'Commission Paid Done' || val === 'Invoice Processed-Term 2') {
            return <div className={styles.maxCommission}>{val === "Commission Received-Term 2" ? "Invoice Processed-Term 2" : val}</div>
        }

        if (val === 'Withdrawn - Bad Debts' || val === 'Invoice Processed-Term 3') {
            return <div className={styles.withdrawn}>{val === "Invoice Processed-Term 3" ? "Commission Received-Term 3" : val}</div>
        }
        if (val === 'To Be Invoiced' || val === 'Auto PI Generated') {
            return <div className={styles.Invoiced}>{val}</div>
        }
        if (val && typeof val === 'string' && val.includes('Commission Pending')) {
            return (
                <div style={{
                    color: '#d48806',
                    background: '#fffbe6',
                    border: '1px solid #ffe58f',
                    padding: '5px 12px',
                    borderRadius: '3px',
                    display: 'inline-block',
                    fontSize: '10px',
                    fontWeight: 'bold'
                }}>
                    {val}
                </div>
            );
        }
        if (val === 'Invoice Processed-Term 5') {
            return <div className={styles.Term5}>{val === "Invoice Processed-Term 5" ? "Commission Received-Term 5" : val}</div>
        }
    }

    checkTodaysEnrollment = async () => {
        let response = await Request.checkTodayStudentEnrollment()
        if (response && response.count > 0) {
            this.setState({ showEnrollmentDrawer: true })
        }

    }

    loadCountries = async (params = {}) => {
        params.results = 1000;
        params.count = 1000;
        params.businessId = activeUser && activeUser.businessId;
        let { data } = await Request.getCountriesWithoutAuth(params);
        data = data.reduce((temp, vv) => {
            temp.push({ value: vv._id, text: vv.countryName });
            return temp;
        }, []);

        this.setState({ countries: data });
    }

    componentWillMount() {
        this.setState({ deskColor: Settings.deskColor('Claim Desk') })
    }

    loadCommunicationSetting = async () => {
        let response = await Request.getCommunicationSettings();
        if (response && response.doc) {
            let doc = response.doc;
            this.setState({
                invoicePrefixes: {
                    performaInvoiceNumberPrefix: doc.performaInvoiceNumberPrefix ? doc.performaInvoiceNumberPrefix : 'TP',
                    // groupedPerformaInvoiceNumberPrefix: doc.groupedPerformaInvoiceNumberPrefix ? doc.groupedPerformaInvoiceNumberPrefix : 'TP',
                    invoiceNumberPrefix: doc.invoiceNumberPrefix ? doc.invoiceNumberPrefix : 'TP'
                }
            })
        }
    }

    loadBranchInvoices = async () => {
        let response = await Request.getBranchGeneratedInvoices();
        if (response.total > 0) {
            this.setState({ showBranchInvoiceDrawer: true })
        } else {
            this.setState({ showBranchInvoiceDrawer: false })
        }
    }

    componentDidMount() {
        this.checkTodaysEnrollment()
        this.loadCountries();
        this.loadCommunicationSetting();
        this.loadBranchPlan();
        window.onkeydown = function (e) {
            var ck = e.keyCode ? e.keyCode : e.which;
            if (e.ctrlKey && ck == 70) {
                if (document.querySelector('#search-student-input')) {
                    document.querySelector('#search-student-input').focus();
                }
                return false;
            } else if (ck == 27) {
                if (document.querySelector('#search-student-input')) {
                    document.querySelector('#search-student-input').focus();
                }
                return false;
            }
        }
        this.loadBranchInvoices();
    }

    followUpsCallback() {
        let { isFollowUpOverdue } = this.state;
        this.setState({
            isFollowUpOverdue: !isFollowUpOverdue,
        }, () => {
            this.table.current.reload()
        });
    }

    chooseRangerPickerInvoiceDesk = (date, dateString) => {
        this.setState(
            {
                generationDate: dateString
            }, () => {
                this.table.current.reload();
            }
        )
    }

    // chooseRangerPicker = (date, dateString) => {
    //     this.setState(
    //         {
    //             invoiceGenerationDate: {
    //                 from: moment(date[0]).startOf('day'),
    //                 to: moment(date[1]).endOf('day'),
    //             }
    //         }, () => {
    //             if (date[0] == undefined) {
    //                 if (this.table && this.table.current) {
    //                     this.table.current.reload();
    //                 }
    //             }
    //         }
    //     )
    // }

    chooseRangerPicker = (date, dateString) => {
        let invoiceGenerationDate = null;

        if (date && date.length) {
            invoiceGenerationDate = {
                from: moment(date[0]).startOf('day'),
                to: moment(date[1]).endOf('day'),
            };
        }

        this.setState(
            { invoiceGenerationDate: invoiceGenerationDate },
            () => {
                if (this.table && this.table.current) {
                    this.table.current.reload();
                }
            }
        );
    };

    onOk = value => {
        this.table.current.reload()
    }

    closeEnrollmentDrawer = () => {
        this.setState({ showEnrollmentDrawer: false }, () => {
            this.table.current.reload()
        })
    }

    getOverdueClass = (generationDate) => {
        if (generationDate && moment(generationDate).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
            return 'red-overdue';
        }
        return '';
    }

    selectMultiRecords = async (e, record, invoiceGenerationRecord, index) => {
        let invoiceGeneratedRecordId = invoiceGenerationRecord._id;
        let studentId = record._id;
        let studentIdKey = `${studentId}-${index}`
        let universityId = record.visaDesk.selectedCourse.universityId;
        let response = await Request.getUniversity(record.visaDesk.selectedCourse.universityId);
        let universityPartnership = record.visaDesk.selectedCourse.universityPartnership;
        let currency = record.visaDesk.selectedCourse.currency;
        let selectedCourse = record.visaDesk.selectedCourse ? record.visaDesk.selectedCourse : {};
        let tutionFee = selectedCourse.tutionFee ? selectedCourse.tutionFee : 0;
        let selectMultipleRecords = this.state.selectMultipleRecords;
        if (e.target.checked == true) {
            selectMultipleRecords[studentIdKey] = {
                universityName: response.doc.universityInstitutionName,
                universityAgreement: response.doc.paymentUpload && response.doc.paymentUpload[0] ? `${MEDIA_URL}${response.doc.paymentUpload[0].url}` : null,
                universityPartnership,
                universityId,
                currency,
                studentId,
                invoiceGeneratedRecordId,
                tutionFee,
                record
            };
        } else {
            if (selectMultipleRecords[studentIdKey] != undefined) {
                delete selectMultipleRecords[studentIdKey];
            }
        }
        this.setState({ selectMultipleRecords });
    }


    doUploadMultipleInvoices = () => {
        let selectMultipleRecords = this.state.selectMultipleRecords;
        let count = 0
        for (const key in selectMultipleRecords) {
            if (Object.hasOwnProperty.call(selectMultipleRecords, key)) {
                const selectMultipleRecord = selectMultipleRecords[key];
                if (selectMultipleRecord.universityId) {
                    count++;
                }
            }
        }
        if (count == 0) {
            notification.error({
                message: 'Please select atleast 1 record.'
            });
            return false;
        }
        this.uploadCompanyDetails();
    }


    uploadCompanyDetails = async () => {
        this.setState({ showUploadDetailForm: true })
    }

    closeUploadCompanyDetails = async () => {
        this.setState({ showUploadDetailForm: false, selectMultipleRecords: [] }, () => {
            this.table.current.reload();
        })
    }

    doGenerateMultipleInvoices = () => {
        let selectMultipleRecords = this.state.selectMultipleRecords;
        let count = 0;
        for (const key in selectMultipleRecords) {
            if (Object.hasOwnProperty.call(selectMultipleRecords, key)) {
                const selectMultipleRecord = selectMultipleRecords[key];
                if (selectMultipleRecord.universityId) {
                    count++;
                }
            }
        }
        if (count == 0) {
            notification.error({
                message: 'Please select atleast 1 record.'
            });
            return false;
        }
        this.selectCompanyDetails();
    }

    selectCompanyDetails = async () => {
        this.setState({ showCompanyDetailForm: true });
    }

    closeDocument = () => {
        this.setState({ showCompanyDetailForm: false });
    }
    selectCompanyBankId = (formData) => {
        this.setState({ enableBTN: false, showCompanyDetailForm: false }, () => {
            this.setState({ selectMultipleRecords: [] });
        });
        if (this.table && this.table.current) {
            this.table.current.reload();
        }
    }

    moveToArchiveDesk = async () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            let moveReason = prompt('Enter Valid Reason for moving Student to archive');
            if (!moveReason) {
                notification.error({
                    message: 'Provide a Valid Reason to Move Student'
                });
                return;
            }
            let moveData = {
                atLevel: 'Archive Desk',
                reason: moveReason,
            }
            await Promise.all(
                userArr.map(item =>
                    Request.changeDesk({ ...moveData, _id: item._id })
                )
            );

            notification.success({
                message: `${userArr.length} Move Request Sent Sucess`
            });
            this.table.current.reload();
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }

    showSelectedStudentDrawr = () => {
        let selectMultipleRecords = this.state.selectMultipleRecords
        let count = 0;
        for (const key in selectMultipleRecords) {
            if (Object.hasOwnProperty.call(selectMultipleRecords, key)) {
                const selectMultipleRecord = selectMultipleRecords[key];
                if (selectMultipleRecord.universityId) {
                    count++;
                }
            }
        }
        if (count == 0) {
            return notification.warning('Please select atleast 1 student to generate invoice.');
        } else {
            this.setState({ selectMultipleRecordsData: selectMultipleRecords, showSelectedInvoices: true })
        }
    }
    closeStudentInvoiceDrawr = () => {
        this.setState({ showSelectedInvoices: false })
    }

    render() {



        const {
            allBranches = [],
            claimDeskRights,
            deskColor,
            invoiceStatusList,
            invoiceStatusList2,
            termList,
            invoiceStatuses,
            invoiceStatus,
            channelPartnerList,
            paymentBalance,
            counsellors,
            selectMultipleRecords,
            selectMultipleRecordsData,
            showCompanyDetailForm,
            showUploadDetailForm,
            enableBTN,
            showSelectedInvoices,
            channelPartners,
            universities,
            showReviewDrawer,
            inquiryDetail,
            invoicesTotal,
            enrollmentStatusArr,
            invoiceStatsArr,
            statusStatsArr
        } = this.state;


        const getStatCard = ({ statusName, count }, index, spanSize, action) => {
            let key = statusName === "Follow-Ups" ? !this.state[action] : statusName;
            const color = COLORS[index % COLORS.length];
            const isSelected = statusName === "Follow-Ups" ? this.state[action] : this.state[action] === key;
            return (
                <Col
                    key={key}
                    span={spanSize}
                    style={{ marginBottom: "1rem", flex: 1, minWidth: 0 }}
                >
                    <div
                        className={styles.statCard}
                        style={{
                            padding: "15px 20px",
                            background: isSelected ? "#f0f5ff" : "#fff",
                            border: isSelected
                                ? `1px solid ${color}`
                                : "1px solid transparent",
                            borderRadius: "10px",
                            boxShadow: isSelected
                                ? `0 4px 12px ${color}40`
                                : "none",
                            display: "flex",
                            flexDirection: "column",
                            cursor: "pointer",
                            transition: "all 0.3s ease"
                        }}
                        onClick={() => {
                            let newState = {
                                enrollmentStat: null,
                                invoiceStat: null,
                                statusStat: null,
                                isFollowUpOverdue: false
                            };

                            if (this.state[action] !== key) {
                                newState[action] = key;
                            }


                            this.setState(newState, () => {
                                if (key === "Follow-Ups") {
                                    this.followUpsCallback()
                                } else {
                                    this.table.current.reload();
                                }

                            })
                        }}
                    >
                        <div
                            className={styles.mutedText}
                            style={{
                                marginBottom: 8,
                                fontSize: "14px",
                                color: "#8c8c8c"
                            }}
                        >
                            {statusName}
                        </div>
                        <div
                            className={styles.statValue}
                            style={{
                                fontSize: "28px",
                                fontWeight: "bold",
                                color: color,
                                lineHeight: 1
                            }}
                        >
                            {count}
                        </div>
                    </div>
                </Col>
            )
        }

        // Stats Card Start
        const statCard = <>
            {/* Enrollment Status */}
            <Row gutter={16} type="flex" style={{ marginBottom: 0 }}>
                {
                    (enrollmentStatusArr || []).filter((s) => s && s.statusName).map((detail, index) => {
                        const spanSize = (24 / enrollmentStatusArr.length);
                        return getStatCard(detail, index, spanSize, 'enrollmentStat')
                    })
                }
            </Row>
            <Row gutter={16} type="flex" style={{ marginBottom: 0 }}>
                {[
                    ...(invoiceStatsArr || []).filter((s) => {
                        if (!s || !s.statusName) return false;

                        if (
                            claimDeskRights &&
                            claimDeskRights.viewByBranch &&
                            s.statusName === "Invoices due for generation"
                        ) {
                            return false;
                        }

                        return true;
                    }),

                    ...(
                        claimDeskRights &&
                            claimDeskRights.viewByBranch
                            ? [
                                {
                                    statusName: "Follow-Ups",
                                    count: this.state.followDuesCount
                                }
                            ]
                            : []
                    )
                ].map((detail, index) => {
                    return getStatCard(
                        detail,
                        index,
                        null,
                        detail.statusName === "Follow-Ups"
                            ? "isFollowUpOverdue"
                            : "invoiceStat"
                    );
                })}
            </Row>
            {/* {
                claimDeskRights && !claimDeskRights.viewByBranch && (
                    <Row gutter={16} type="flex" style={{ marginBottom: 0 }}>
                        {
                            (statusStatsArr || []).filter((s) => s && s.statusName).map((detail, index) => {
                                const spanSize = (24 / statusStatsArr.length);
                                return getStatCard(detail, index, spanSize, 'statusStat')
                            })
                        }
                    </Row>
                )
            } */}
            {
                claimDeskRights && !claimDeskRights.viewByBranch && (
                    <Row
                        gutter={16}
                        type="flex"
                        style={{
                            display: 'flex',
                            width: '100%'
                        }}
                    >
                        {[
                            ...(statusStatsArr || []).filter(
                                s => s && s.statusName
                            ),
                            {
                                statusName: 'Follow-Ups',
                                count: this.state.followDuesCount
                            }
                        ].map((detail, index, arr) => {
                            return getStatCard(
                                detail,
                                index,
                                null,
                                detail.statusName === "Follow-Ups" ? 'isFollowUpOverdue' : 'statusStat'
                            );
                        })}
                    </Row>
                )
            }
        </>


        // Stats Card End
        let { showEnrollmentDrawer, universityInstitutionName, channelPartnerId, studentBranchId, selectedDates, countries } = this.state
        function renderInvoiceReviewStatus(record, date) {
            var reviewDetails =
                record && record.invoiceReviewDetails ? record.invoiceReviewDetails : {};

            var text = reviewDetails.reviewStatus;

            if (!text) {
                return null;
            }

            var reviewedByUser = reviewDetails.reviewedByUser
                ? reviewDetails.reviewedByUser
                : null;

            var reviewerName =
                reviewedByUser && reviewedByUser.name ? reviewedByUser.name : "";

            var rawDate =
                reviewedByUser && reviewedByUser.time
                    ? reviewedByUser.time.$date
                        ? reviewedByUser.time.$date
                        : reviewedByUser.time
                    : null;

            var labels = {
                studentRecord: "Student Record",
                intakeDate: "Intake Date",
                tutionFeeAmount: "Tuition Fee Amount",
                tutionFeePayment: "Tuition Fee Payment",
                universityOrCPinformation: "University/CP Info",
                branchOrApinformation: "Branch/AP Info",
                swiftCopy: "Swift Copy",
                piInvoiceCount: "PI Invoice Count",
                piInvoiceAmount: "PI Invoice Amount"
            };

            var totalItems = Object.keys(labels).length;
            var completedItems = Object.keys(labels).filter(function (key) {
                return reviewDetails[key] === true;
            }).length;

            var progressPercent = Math.round(
                (completedItems / totalItems) * 100
            );

            var statusClass = "bg-grey";
            var iconType = "info-circle";

            if (text === "Under Review") {
                statusClass = "bg-amber";
                iconType = "sync";
            } else if (text === "Verified") {
                statusClass = "bg-blue";
                iconType = "check-square";
            } else if (text === "Max Commission Paid") {
                statusClass = "bg-green";
                iconType = "dollar";
            }

            var popoverContent = (
                <div style={{ minWidth: "220px" }}>
                    <div style={{ marginBottom: 8 }}>
                        <Progress
                            percent={progressPercent}
                            size="small"
                            format={function () {
                                return completedItems + "/" + totalItems;
                            }}
                        />
                    </div>

                    {Object.keys(labels).map(function (key) {
                        var done = reviewDetails[key] === true;
                        return (
                            <div
                                key={key}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    fontSize: "12px",
                                    marginBottom: 4
                                }}
                            >
                                <span>{labels[key]}</span>
                                <Icon
                                    type={done ? "check-circle" : "close-circle"}
                                    theme={done ? "filled" : "outlined"}
                                    style={{ color: done ? "#52c41a" : "#d9d9d9" }}
                                />
                            </div>
                        );
                    })}
                </div>
            );

            return (
                <div style={{ marginTop: 6 }}>
                    <Popover content={popoverContent} placement="left">
                        <div
                            className={statusClass}
                            style={{
                                padding: "3px 8px",
                                fontSize: "10px",
                                borderRadius: 4,
                                fontWeight: 700,
                                display: "inline-flex",
                                alignItems: "center",
                                cursor: "help"
                            }}
                        >
                            <Icon
                                type={iconType}
                                spin={text === "Under Review"}
                                style={{ marginRight: 5 }}
                            />
                            {text.toUpperCase()}
                        </div>
                    </Popover>

                    {/* {reviewerName && (
                        <div style={{ fontSize: "10px", marginTop: 2 }}>
                            {reviewerName}
                        </div>
                    )}

                    {rawDate && (
                        <div style={{ fontSize: "9px", color: "#8c8c8c" }}>
                            {moment(rawDate).format(dateFormat + " HH:mm")}
                        </div>
                    )} */}
                </div>
            );
        }
        let count = 0;
        for (const key in selectMultipleRecords) {
            if (Object.hasOwnProperty.call(selectMultipleRecords, key)) {
                const selectMultipleRecord = selectMultipleRecords[key];
                if (selectMultipleRecord.universityId) {
                    count++;
                }
            }
        }
        const content = <div>
            {claimDeskRights && !claimDeskRights.viewByBranch ?
                <p>This section of the claims desk allows you to view a list of all visa-approved students<br></br> (excluding archived ones) along with their commission terms for invoice generation. You<br></br> can apply filters as needed to refine the list. Commission can be claimed for a single<br></br> student or multiple students by selecting their checkboxes and clicking the<br></br> "Generate Invoice" button.</p>
                :
                <p>This section of the claims desk allows you to view a list of all your visa-approved students<br></br> (excluding bad debts and fully claimed ones) along with their commission terms and status.<br></br> Click on View Button to see summary and commission/Invoice Status. You can apply<br></br> filters as needed to refine the list.</p>
            }
        </div>


        const currencySymbols = {
            USD: "$",      // US Dollar
            EUR: "€",      // Euro
            GBP: "£",      // British Pound
            INR: "₹",      // Indian Rupee
            AUD: "A$",     // Australian Dollar
            CAD: "C$",     // Canadian Dollar
            JPY: "¥",      // Japanese Yen
            CNY: "¥",      // Chinese Yuan
            NZD: "NZ$",    // New Zealand Dollar
            CHF: "CHF",    // Swiss Franc
            SGD: "S$",     // Singapore Dollar
            HKD: "HK$",    // Hong Kong Dollar
            SEK: "kr",     // Swedish Krona
            NOK: "kr",     // Norwegian Krone
            DKK: "kr",     // Danish Krone
            ZAR: "R",      // South African Rand
            AED: "د.إ",    // UAE Dirham
            SAR: "﷼",     // Saudi Riyal
            THB: "฿",      // Thai Baht
            MYR: "RM",     // Malaysian Ringgit
            IDR: "Rp",     // Indonesian Rupiah
            KRW: "₩",      // South Korean Won
            TRY: "₺",      // Turkish Lira
            RUB: "₽",      // Russian Ruble
            BRL: "R$",     // Brazilian Real
            MXN: "$",      // Mexican Peso
            PHP: "₱",      // Philippine Peso
            PLN: "zł",     // Polish Zloty
            HUF: "Ft",     // Hungarian Forint
            CZK: "Kč",     // Czech Koruna
        };

        const getFinalAmount = (date, record) => {

            var generatedInvoices = record && record.generatedInvoices ? record.generatedInvoices : [];
            var visaDesk = record && record.visaDesk ? record.visaDesk : null;
            var selectedCourse = visaDesk && visaDesk.selectedCourse ? visaDesk.selectedCourse : null;

            var currency = selectedCourse && selectedCourse.currency ? selectedCourse.currency : '';
            var commissionAmount = 0;

            var inv = date && date.invoiceGeneratedNumber
                ? date.invoiceGeneratedNumber
                : (date && date.cpInvoiceNumber ? date.cpInvoiceNumber : null);

            var matchingInvs = generatedInvoices.filter(function (gi) {
                return gi.invoiceNumber === inv;
            });
            var foundInvoice = matchingInvs.length > 0 ? matchingInvs[matchingInvs.length - 1] : null;

            var invoiceDetail = null;
            if (foundInvoice && foundInvoice.invoices && foundInvoice.invoices.length > 0) {
                invoiceDetail = foundInvoice.invoices.find(function (invDet) {
                    return String(invDet.invoiceGeneratedRecordId) === String(date._id);
                });
            }

            if (invoiceDetail) {
                var amt = Number(invoiceDetail.commissionTotal);
                commissionAmount = !isNaN(amt) ? amt : 0;
            } else if (date && date.commReceived) {
                var recAmt = Number(date.commReceived);
                commissionAmount = !isNaN(recAmt) ? recAmt : 0;
            }

            var finalAmount = Number(commissionAmount);

            if (
                claimDeskRights &&
                claimDeskRights.viewByBranch &&
                this.state.branchPlan
            ) {
                var branchPlan = this.state.branchPlan;

                if (branchPlan.commissionType === 'Flat') {
                    finalAmount = Number(branchPlan.commission) || 0;
                } else if (branchPlan.commissionType === 'Percentage') {
                    var percent = Number(branchPlan.commission) || 0;
                    finalAmount = (finalAmount * percent) / 100;
                }
            }

            return finalAmount;
        };
        const columns = [
            {
                title: 'Action',
                key: 'operation',
                dataindex: 'operation',
                width: 120,
                render: (text, record) => (
                    <React.Fragment>
                        <div className={styles.btnWrapper}>
                            <span className={styles.userSelectCheckbox}>
                                <Checkbox
                                    checked={userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false}
                                    onChange={y => {
                                        this.selectUser(y, record._id)
                                    }}>
                                </Checkbox>
                            </span>
                            <Tooltip title="Notes">
                                <Button
                                    className={styles.btn}
                                    shape="circle"
                                    size={'small'}
                                    onClick={() => this.openFollowUps(record)}
                                    icon="calendar"
                                />
                            </Tooltip>
                            <Tooltip title="Click To Edit Details">
                                <Button
                                    className={styles.btn}
                                    size={'small'}
                                    shape="circle"
                                    href={`/desk/getClaim?id=${record._id}`}
                                    icon="edit"
                                />
                            </Tooltip>
                            {
                                record &&
                                record.nextInvoiceGenerationDates &&
                                record.nextInvoiceGenerationDates.length > 0 &&
                                claimDeskRights && !claimDeskRights.viewByBranch &&
                                record.nextInvoiceGenerationDates.some(function (item) {
                                    return item.invoiceGenerated === false;
                                }) && (
                                    <Tooltip title="Generate Auto PI">
                                        <Popconfirm
                                            title="Are you sure to create Auto PI?"
                                            onConfirm={() => {
                                                this.generateAutoPI(record._id);
                                            }}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Button
                                                className={styles.btn}
                                                shape="circle"
                                                size="small"
                                                icon="forward"
                                                loading={this.state.loading}
                                            />
                                        </Popconfirm>
                                    </Tooltip>
                                )
                            }
                            {
                                claimDeskRights && !claimDeskRights.viewByBranch && (
                                    <Tooltip title="Add/Update Review Status">
                                        <Button
                                            className={styles.btn}
                                            size={'small'}
                                            shape='circle'
                                            icon='check'
                                            onClick={() => { this.setState({ showReviewDrawer: true, inquiryDetail: record }) }}
                                        />
                                    </Tooltip>
                                )
                            }

                        </div>
                    </React.Fragment>
                )
            },
            {
                title: 'Visa Date',
                key: 'visaDate',
                dataIndex: 'visaDesk.visaApprovalDate',
                searchTextName: `${dateFormat}`,
                width: 100,
                render: (text, record) => {
                    let visaApprovalDate = record && record.visaDesk && record.visaDesk.visaApprovalDate ? record.visaDesk.visaApprovalDate : null;
                    return (
                        <div>{visaApprovalDate ? moment(visaApprovalDate).local().format(dateFormat) : "NA"}</div>
                    )
                }
            },
            {
                title: 'Invoice Details',
                key: 'nextInvoiceGenerationDates.invoiceGeneratedNumber',
                dataIndex: 'nextInvoiceGenerationDates.invoiceGeneratedNumber',
                searchTextName: `Inv. No./${dateFormat}`,
                width: 280,

                render: (generationDates, record) => {

                    var nextInvoiceGenerationDates =
                        record && record.nextInvoiceGenerationDates
                            ? record.nextInvoiceGenerationDates
                            : [];

                    var lastInvoice =
                        nextInvoiceGenerationDates.length > 0
                            ? nextInvoiceGenerationDates[nextInvoiceGenerationDates.length - 1]
                            : {};

                    var generatedInvoices =
                        record && record.generatedInvoices
                            ? record.generatedInvoices
                            : [];

                    var visaDesk =
                        record && record.visaDesk
                            ? record.visaDesk
                            : null;

                    var selectedCourse =
                        visaDesk && visaDesk.selectedCourse
                            ? visaDesk.selectedCourse
                            : null;

                    var universityDetails =
                        selectedCourse && selectedCourse.universityDetails
                            ? selectedCourse.universityDetails
                            : null;

                    var paymentDueDays =
                        universityDetails &&
                            universityDetails.paymentTimeline
                            ? Number(universityDetails.paymentTimeline)
                            : 0;

                    if (!nextInvoiceGenerationDates.length) {
                        return (
                            <div
                                style={{
                                    padding: '16px',
                                    border: '1px dashed #ffa39e',
                                    borderRadius: '8px',
                                    textAlign: 'center',
                                    background: '#fff1f0'
                                }}
                            >
                                <small
                                    style={{
                                        color: '#f5222d',
                                        fontSize: '12px',
                                        fontWeight: 600
                                    }}
                                >
                                    <Icon
                                        type="warning"
                                        style={{ marginRight: 6 }}
                                    />

                                    No Invoices Scheduled
                                </small>
                            </div>
                        );
                    }

                    var getStatusStyles = function (status) {

                        var s = status
                            ? status.toUpperCase()
                            : 'PENDING';

                        var config = {

                            'PENDING': {
                                color: '#d48806',
                                bg: '#fffbe6',
                                border: '#ffe58f'
                            },

                            'GENERATED': {
                                color: '#08979c',
                                bg: '#e6fffb',
                                border: '#87e8de'
                            },

                            'SUBMITTED TO UNI': {
                                color: '#096dd9',
                                bg: '#e6f7ff',
                                border: '#91d5ff'
                            },

                            'APPROVED BY UNI': {
                                color: '#389e0d',
                                bg: '#f6ffed',
                                border: '#b7eb8f'
                            },

                            'PAID BY UNI': {
                                color: '#531dab',
                                bg: '#f9f0ff',
                                border: '#d3adf7'
                            },

                            'CLEARED': {
                                color: '#237804',
                                bg: '#f6ffed',
                                border: '#95de64'
                            }
                        };

                        return config[s] || {
                            color: '#595959',
                            bg: '#f5f5f5',
                            border: '#d9d9d9'
                        };
                    };

                    return (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '14px',
                                padding: '4px'
                            }}
                        >

                            {nextInvoiceGenerationDates.map(function (date, index) {

                                var studentIdKey =
                                    record._id + '-' + index;

                                var ifChecked =
                                    selectMultipleRecords &&
                                    selectMultipleRecords[studentIdKey] &&
                                    selectMultipleRecords[studentIdKey].invoiceGeneratedRecordId == date._id;

                                var inv =
                                    date && date.invoiceGeneratedNumber
                                        ? date.invoiceGeneratedNumber
                                        : (
                                            date && date.cpInvoiceNumber
                                                ? date.cpInvoiceNumber
                                                : null
                                        );

                                var url =
                                    (
                                        inv &&
                                        (
                                            inv.startsWith('PI-TP-') ||
                                            inv.startsWith('GPI-')
                                        )
                                    ) ||
                                        date.invoiceStatus === "Draft"
                                        ? "/finance-desk-performa?invSTId=" +
                                        (date._id
                                            ? (date._id.$oid || date._id)
                                            : '')
                                        : "/finance-desk?invSTId=" +
                                        (date._id
                                            ? (date._id.$oid || date._id)
                                            : '');

                                var currency =
                                    selectedCourse &&
                                        selectedCourse.currency
                                        ? selectedCourse.currency
                                        : '';

                                var commissionAmount = 0;

                                var matchingInvs =
                                    generatedInvoices.filter(function (gi) {
                                        return (
                                            gi.invoiceNumber === inv
                                        );
                                    });
                                var foundInvoice = matchingInvs.length > 0 ? matchingInvs[matchingInvs.length - 1] : null;

                                var invoiceGeneratedDate =
                                    foundInvoice &&
                                        foundInvoice.invoiceGeneratedDate
                                        ? foundInvoice.invoiceGeneratedDate
                                        : null;

                                var invoiceDetail = null;

                                if (
                                    foundInvoice &&
                                    foundInvoice.invoices &&
                                    foundInvoice.invoices.length > 0
                                ) {

                                    invoiceDetail =
                                        foundInvoice.invoices.find(function (invDet) {

                                            return (
                                                String(invDet.invoiceGeneratedRecordId) ===
                                                String(date._id)
                                            );
                                        });
                                }

                                if (invoiceDetail) {

                                    commissionAmount =
                                        Number(invoiceDetail.commissionTotal) || 0;

                                    currency =
                                        invoiceDetail.currency || currency;

                                } else if (
                                    date &&
                                    date.commReceived
                                ) {

                                    commissionAmount =
                                        Number(date.commReceived) || 0;
                                }

                                var finalAmount =
                                    Number(commissionAmount);

                                if (
                                    claimDeskRights &&
                                    claimDeskRights.viewByBranch &&
                                    this.state.branchPlan
                                ) {

                                    var branchPlan =
                                        this.state.branchPlan;

                                    if (
                                        branchPlan.commissionType === 'Flat'
                                    ) {

                                        finalAmount =
                                            Number(branchPlan.commission) || 0;

                                    } else if (
                                        branchPlan.commissionType === 'Percentage'
                                    ) {

                                        var percent =
                                            Number(branchPlan.commission) || 0;

                                        finalAmount =
                                            (finalAmount * percent) / 100;
                                    }
                                }

                                /* =========================================================
                                    UPDATED STATUS DETERMINATION LOGIC
                                ========================================================= */

                                var currentStatusText = 'PENDING';

                                if (date && date.uploaded === true) {
                                    currentStatusText = date.invoiceStatus || 'PENDING';
                                } else if (date && date.invoiceGenerated === true) {
                                    currentStatusText = (foundInvoice && foundInvoice.invoiceStatus)
                                        ? foundInvoice.invoiceStatus
                                        : 'GENERATED';
                                } else {
                                    currentStatusText = 'PENDING';
                                }

                                var statusStyles =
                                    getStatusStyles(currentStatusText);

                                var statusUpper =
                                    currentStatusText
                                        ? currentStatusText.toUpperCase()
                                        : 'PENDING';


                                /* =========================================================
                                    PAYMENT DUE DATE LOGIC
                                ========================================================= */

                                var invoiceType =
                                    foundInvoice &&
                                        foundInvoice.invoiceType
                                        ? foundInvoice.invoiceType
                                        : '';

                                var baseDate = null;

                                if (invoiceType === 'Invoice') {

                                    if (
                                        foundInvoice &&
                                        foundInvoice.invoiceGeneratedDate
                                    ) {

                                        baseDate =
                                            foundInvoice.invoiceGeneratedDate;

                                    } else if (invoiceGeneratedDate) {

                                        baseDate =
                                            invoiceGeneratedDate;

                                    } else {

                                        baseDate =
                                            date.generationDate;
                                    }

                                } else {

                                    baseDate =
                                        date.generationDate;
                                }


                                /* =========================================================
                                    DUE DATE
                                ========================================================= */

                                var dueDate = null;

                                if (
                                    paymentDueDays &&
                                    baseDate
                                ) {

                                    dueDate =
                                        moment(baseDate)
                                            .add(
                                                Number(paymentDueDays),
                                                'days'
                                            )
                                            .startOf('day');
                                }


                                /* =========================================================
                                    HIDE DUE ON
                                ========================================================= */

                                var hideDueOn =
                                    statusUpper === 'CLEARED' ||
                                    statusUpper === 'PAID BY UNI';


                                /* =========================================================
                                    DELAY CALCULATION
                                ========================================================= */

                                var today =
                                    moment().startOf('day');

                                var isPaymentPending =
                                    statusUpper !== 'CLEARED' &&
                                    statusUpper !== 'PAID BY UNI';

                                var isDelayed =
                                    dueDate &&
                                    dueDate.isBefore(today) &&
                                    isPaymentPending;


                                /* =========================================================
                                    DELAY TEXT
                                ========================================================= */

                                var delayText = '';

                                if (isDelayed) {

                                    var totalDays =
                                        today.diff(dueDate, 'days');

                                    if (totalDays < 7) {

                                        delayText =
                                            totalDays + 'D';

                                    } else if (totalDays < 30) {

                                        delayText =
                                            Math.floor(totalDays / 7) +
                                            'W ' +
                                            (totalDays % 7) +
                                            'D';

                                    } else {

                                        delayText =
                                            Math.floor(totalDays / 30) +
                                            'M ' +
                                            (totalDays % 30) +
                                            'D';
                                    }
                                }

                                /* Safe data structures parsing */
                                var targetObj = (foundInvoice && foundInvoice._id) ? foundInvoice : date;
                                var createdBy = targetObj.createdByUser || date.createdByUser;
                                var verifiedBy = record && record.invoiceReviewDetails && record.invoiceReviewDetails.reviewedByUser && record.invoiceReviewDetails.reviewStatus === "Verified" ? record.invoiceReviewDetails.reviewedByUser : null;
                                var approvedBy = targetObj.invoiceApprovalUpdatedBy || date.invoiceApprovalUpdatedBy;
                                var submittedBy = targetObj.submittedByUser || date.submittedByUser;
                                var clearedBy = targetObj.clearRequestAddedBy || date.clearRequestAddedBy;

                                // Evaluation layer to see if the whole block should display
                                var dynamicWorkflowTrailHasData = !!(createdBy || verifiedBy || approvedBy || submittedBy || clearedBy);

                                return (

                                    <div
                                        key={index}
                                        style={{
                                            padding: '12px 14px',
                                            background: '#fff',
                                            borderRadius: '10px',
                                            border: '1px solid #f0f0f0',
                                            boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
                                            transition: 'all 0.3s'
                                        }}
                                    >

                                        {/* HEADER */}

                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                marginBottom: '10px'
                                            }}
                                        >

                                            <div>
                                                {claimDeskRights &&
                                                    !claimDeskRights.viewByBranch ? (

                                                    <Checkbox
                                                        checked={ifChecked}
                                                        onChange={(e) =>
                                                            this.selectMultiRecords(
                                                                e,
                                                                record,
                                                                date,
                                                                index
                                                            )
                                                        }
                                                    >

                                                        <span
                                                            style={{
                                                                fontWeight: 700,
                                                                fontSize: '13px'
                                                            }}
                                                        >

                                                            {inv ? (

                                                                <a
                                                                    target="_blank"
                                                                    href={url}
                                                                    style={{
                                                                        color: '#096dd9',
                                                                        textDecoration: 'none',
                                                                        borderBottom: '1px dashed #096dd9'
                                                                    }}
                                                                >
                                                                    {inv}
                                                                </a>

                                                            ) : (

                                                                <span
                                                                    style={{
                                                                        color: '#8c8c8c'
                                                                    }}
                                                                >
                                                                    Draft #{date.invoiceNo}
                                                                </span>
                                                            )}
                                                        </span>
                                                    </Checkbox>

                                                ) : (

                                                    <span
                                                        style={{
                                                            fontWeight: 700,
                                                            fontSize: '13px',
                                                            color: '#262626'
                                                        }}
                                                    >
                                                        {"T" + date.invoiceNo}
                                                    </span>
                                                )}
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: '11px',
                                                    color: '#595959',
                                                    background: '#f5f5f5',
                                                    padding: '3px 8px',
                                                    borderRadius: '4px',
                                                    border: '1px solid #e8e8e8'
                                                }}
                                            >

                                                <Icon
                                                    type="calendar"
                                                    style={{
                                                        marginRight: 5,
                                                        color: '#8c8c8c'
                                                    }}
                                                />

                                                {moment(date.generationDate)
                                                    .format('DD.MM.YYYY')}
                                            </div>
                                        </div>


                                        {/* BODY */}

                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-end'
                                            }}
                                        >
                                            <div>

                                                <div
                                                    style={{
                                                        fontSize: '18px',
                                                        fontWeight: 800,
                                                        color: '#141414',
                                                        lineHeight: 1.2
                                                    }}
                                                >

                                                    {currencySymbols[currency] || currency}
                                                    {Number(finalAmount).toFixed(2)}
                                                </div>

                                                <div
                                                    style={{
                                                        fontSize: '11px',
                                                        color: '#bfbfbf',
                                                        marginTop: '2px'
                                                    }}
                                                >
                                                    Track: T{date.invoiceNo} / T{lastInvoice.invoiceNo}
                                                </div>
                                            </div>

                                            <div style={{ textAlign: 'right' }}>
                                                <div
                                                    style={{
                                                        fontSize: '10px',
                                                        fontWeight: 700,
                                                        color: statusStyles.color,
                                                        background: statusStyles.bg,
                                                        border: '1px solid ' + statusStyles.border,
                                                        padding: '2px 10px',
                                                        borderRadius: '12px',
                                                        display: 'inline-block',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.4px'
                                                    }}
                                                >
                                                    {currentStatusText}
                                                </div>

                                                <div style={{ marginTop: 6 }}>
                                                    {renderInvoiceReviewStatus(record, date)}
                                                </div>
                                            </div>
                                        </div>


                                        {/* WORKFLOW TRAIL BLOCK - SHOWS BOX IF ANY LOG IS PRESENT AND ONLY RENDERS ROWS INDIVIDUALLY IF THEY EXIST */}
                                        {dynamicWorkflowTrailHasData && (
                                            <div
                                                style={{
                                                    background: '#fafafa',
                                                    borderRadius: '8px',
                                                    padding: '10px 12px',
                                                    border: '1px solid #f0f0f0',
                                                    fontSize: '11px',
                                                    marginTop: '12px'
                                                }}
                                            >
                                                <div style={{ fontWeight: 600, color: '#8c8c8c', textTransform: 'uppercase', fontSize: '9px', letterSpacing: '0.4px', marginBottom: '8px' }}>
                                                    Workflow Trail
                                                </div>

                                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', rowGap: '12px', columnGap: '14px' }}>
                                                    {/* ROW 1 elements visibility setup */}
                                                    {createdBy && (
                                                        <div>
                                                            <div style={{ color: '#8c8c8c' }}>Created By:</div>
                                                            <div style={{ color: '#262626', fontWeight: 600 }}>{createdBy.name}</div>
                                                            <div style={{ color: '#bfbfbf', fontSize: '10px' }}>{createdBy.time ? moment(createdBy.time).format('DD.MM.YYYY HH:mm') : ''}</div>
                                                        </div>
                                                    )}
                                                    {verifiedBy && (
                                                        <div>
                                                            <div style={{ color: '#8c8c8c' }}>Verified By:</div>
                                                            <div style={{ color: '#262626', fontWeight: 600 }}>{verifiedBy.name}</div>
                                                            <div style={{ color: '#bfbfbf', fontSize: '10px' }}>{verifiedBy.time ? moment(verifiedBy.time).format('DD.MM.YYYY HH:mm') : ''}</div>
                                                        </div>
                                                    )}

                                                    {/* ROW 2 elements visibility setup */}
                                                    {approvedBy && (
                                                        <div>
                                                            <div style={{ color: '#8c8c8c' }}>Approved By:</div>
                                                            <div style={{ color: '#262626', fontWeight: 600 }}>{approvedBy.name}</div>
                                                            <div style={{ color: '#bfbfbf', fontSize: '10px' }}>{approvedBy.time ? moment(approvedBy.time).format('DD.MM.YYYY HH:mm') : ''}</div>
                                                        </div>
                                                    )}
                                                    {submittedBy && (
                                                        <div>
                                                            <div style={{ color: '#8c8c8c' }}>Submitted By:</div>
                                                            <div style={{ color: '#262626', fontWeight: 600 }}>{submittedBy.name}</div>
                                                            <div style={{ color: '#bfbfbf', fontSize: '10px' }}>{submittedBy.time ? moment(submittedBy.time).format('DD.MM.YYYY HH:mm') : ''}</div>
                                                        </div>
                                                    )}

                                                    {/* ROW 3 element visibility setup */}
                                                    {clearedBy && (
                                                        <div>
                                                            <div style={{ color: '#8c8c8c' }}>Cleared By:</div>
                                                            <div style={{ color: '#262626', fontWeight: 600 }}>{clearedBy.name}</div>
                                                            <div style={{ color: '#bfbfbf', fontSize: '10px' }}>{clearedBy.time ? moment(clearedBy.time).format('DD.MM.YYYY HH:mm') : ''}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}


                                        {/* FOOTER */}

                                        <div
                                            style={{
                                                marginTop: '12px',
                                                paddingTop: '8px',
                                                borderTop: '1px solid #f5f5f5',
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '10px'
                                            }}
                                        >

                                            {invoiceGeneratedDate && (

                                                <div
                                                    style={{
                                                        fontSize: '11px',
                                                        color: '#52c41a',
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}
                                                >

                                                    <Icon
                                                        type="check-circle"
                                                        theme="filled"
                                                        style={{ marginRight: 4 }}
                                                    />

                                                    Gen:
                                                    {' '}
                                                    {moment(invoiceGeneratedDate)
                                                        .format('DD.MM.YYYY')}
                                                </div>
                                            )}

                                            {dueDate && !hideDueOn && (

                                                <div
                                                    style={{
                                                        fontSize: '11px',
                                                        color: '#fa541c',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        fontWeight: 500
                                                    }}
                                                >

                                                    <Icon
                                                        type="clock-circle"
                                                        style={{ marginRight: 4 }}
                                                    />

                                                    Due:
                                                    {' '}
                                                    {dueDate.format('DD.MM.YYYY')}
                                                </div>
                                            )}


                                            {isDelayed && (

                                                <div
                                                    style={{
                                                        fontSize: '10px',
                                                        color: '#f5222d',
                                                        background: '#fff1f0',
                                                        padding: '1px 8px',
                                                        borderRadius: '4px',
                                                        fontWeight: 700,
                                                        border: '1px solid #ffa39e',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >

                                                    <Icon
                                                        type="warning"
                                                        theme="filled"
                                                        style={{ marginRight: 4 }}
                                                    />

                                                    DELAY:
                                                    {' '}
                                                    {delayText}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );

                            }.bind(this))}
                        </div>
                    );
                }
            },
            {
                title: 'Total Amount',
                key: 'totalAmount',
                width: 120,
                render: (text, record) => {

                    var nextInvoiceGenerationDates = record && record.nextInvoiceGenerationDates
                        ? record.nextInvoiceGenerationDates
                        : [];

                    if (!nextInvoiceGenerationDates.length) return '0.00';

                    var total = 0;

                    nextInvoiceGenerationDates.forEach(function (date) {
                        total += getFinalAmount(date, record);
                    }.bind(this));

                    var visaDesk = record && record.visaDesk ? record.visaDesk : null;
                    var selectedCourse = visaDesk && visaDesk.selectedCourse ? visaDesk.selectedCourse : null;
                    var currency = selectedCourse && selectedCourse.currency ? selectedCourse.currency : 'INR';

                    return (
                        <div style={{ fontWeight: 700 }}>
                            {currencySymbols[currency]}{total.toFixed(2)}
                        </div>
                    );
                }
            },
            {
                title: 'VID',
                key: 'id',
                dataIndex: 'id',
                width: 70,
                searchTextName: 'id',
                filterRegex: true
            },
            {
                title: `Student Name / PPT / DOB/ Uni Id`,
                key: 'studentBasicDetail',
                dataIndex: 'studentName',
                width: 120,
                searchTextName: `Student Name / PPT / ${dateFormat}`,
                filterRegex: true,
                render: (text, record) => {
                    var passport = record && record.visaDesk && record.visaDesk.passportNo
                        ? record.visaDesk.passportNo
                        : (record && record.profile ? record.profile.passportNumber : '');

                    var dob = record && record.dateOfBirth
                        ? moment(record.dateOfBirth).format(dateFormat)
                        : '';

                    var uniId = record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.instituteStudentId ? record.visaDesk.selectedCourse.instituteStudentId : record.instituteStudentId ? record.instituteStudentId : '';

                    return (
                        <div style={{ padding: '4px 0' }}>
                            {/* 1. Primary Student Link */}
                            <div style={{ marginBottom: '6px' }}>
                                <Tooltip title="View Profile">
                                    <a
                                        style={{
                                            color: '#1890ff',
                                            fontWeight: 700,
                                            fontSize: '14px',
                                            letterSpacing: '0.3px'
                                        }}
                                        target={'_blank'}
                                        href={`/inquiry/studentProfileDetails?id=${record._id}`}
                                    >
                                        {text}
                                    </a>
                                </Tooltip>
                            </div>

                            {/* 2. Detail Row with better spacing */}
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                fontSize: '11px',
                                lineHeight: '1.2'
                            }}>
                                {passport && (
                                    <div style={{ marginRight: '12px', marginBottom: '2px' }}>
                                        {/* <span style={{ color: '#8c8c8c', fontWeight: 600 }}>PPT: </span> */}
                                        <span style={{ color: '#262626', fontWeight: 500 }}>{passport}</span>
                                    </div>
                                )}


                            </div>
                            {dob && (
                                <div style={{ marginBottom: '2px' }}>
                                    {/* <span style={{ color: '#8c8c8c', fontWeight: 600 }}>DOB: </span> */}
                                    <span style={{ color: '#262626', fontWeight: 500 }}>{dob}</span>
                                </div>
                            )}
                            {uniId && (
                                <div style={{ marginBottom: '2px' }}>
                                    {/* <span style={{ color: '#8c8c8c', fontWeight: 600 }}>DOB: </span> */}
                                    <span style={{ color: '#262626', fontWeight: 500 }}>{uniId}</span>
                                </div>
                            )}
                        </div>
                    );
                }
            },
            {
                title: 'Final University / Course / Start Date',
                key: 'finalCourseUniversity',
                dataIndex: 'finalCourseUniversity',
                searchTextName: `University/Course/${dateFormat}`,
                width: 220, // Increased width slightly to prevent text cramping
                render: (text, record) => {
                    // Safe data access for React 16.7
                    if (!record || !record.visaDesk || !record.visaDesk.selectedCourse) {
                        return <span style={{ color: '#bfbfbf', fontSize: '11px' }}>Not Selected</span>;
                    }

                    const visaDesk = record.visaDesk;
                    const selectedCourse = visaDesk.selectedCourse;
                    const university = selectedCourse.universityInstitutionName || '';
                    const course = selectedCourse.courseName || '';
                    const courseStartDate = visaDesk.courseStartDate ? moment(visaDesk.courseStartDate).local().format(dateFormat) : "";

                    if (!university && !course) {
                        return null;
                    }

                    return (
                        <div style={{ padding: '4px 0', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            {/* 1. University Name - Primary Information */}
                            <div style={{
                                fontWeight: 700,
                                color: '#262626',
                                fontSize: '13px',
                                lineHeight: '1.4',
                                marginBottom: '2px'
                            }}>
                                <Icon type="bank" style={{ marginRight: 6, color: '#8c8c8c' }} />
                                {university}
                            </div>

                            {/* 2. Course Name - Secondary Information */}
                            {course && (
                                <div style={{
                                    color: '#595959',
                                    fontSize: '12px',
                                    paddingLeft: '18px', // Aligns under the university text, skipping the icon
                                    fontStyle: 'italic'
                                }}>
                                    {course}
                                </div>
                            )}

                            {/* 3. Start Date - Tertiary Information */}
                            {courseStartDate && (
                                <div style={{
                                    marginTop: '4px',
                                    paddingLeft: '18px',
                                    fontSize: '11px',
                                    color: '#1890ff', // Blue color to make the date stand out
                                    fontWeight: 600
                                }}>
                                    <Icon type="calendar" style={{ marginRight: 6 }} />
                                    {courseStartDate}
                                </div>
                            )}
                        </div>
                    );
                }
            },
            {
                title: 'Country',
                key: 'finalCountryId',
                dataIndex: 'visaDesk.selectedCourse.countryId',
                filterRegex: true,
                width: 100,
                filters: countries,
                render: (text, record) => {
                    let countryId = record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.countryId ? record.visaDesk.selectedCourse.countryId : null;
                    let countryName = '';
                    if (countryId) {
                        let countries = this.state.countries;
                        let foundCountry = countries.find(
                            (item) => String(item.value) === String(countryId)
                        );

                        countryName = foundCountry ? foundCountry.text : null;
                    }
                    return (
                        <div>{countryName}</div>
                    )
                }
            },
            {
                title: 'Branch/Sub Agent',
                key: 'studentBranchId',
                width: 130,
                filters: allBranches,
                render: (text, record) => {
                    return (
                        <div>{record && record.associate_partner_details && record.associate_partner_details.branchName ? record.associate_partner_details.branchName : record && record.studentBranchId && record.studentBranchId.branchName ? record.studentBranchId.branchName : ''}</div>
                    )
                }
            },
            {
                title: 'Enrolled At University ?',
                key: 'enrolledInUniversity',
                width: 100,
                render: (text, record) => (
                    <Switch disabled={claimDeskRights.viewByBranch ? true : false} checked={record.enrolledInUniversity} onChange={(checked) => {
                        this.changeStudentEnrollment({ checked, _id: record._id })
                    }} />
                )
            },
            {
                title: 'Consultancy Details',
                key: 'registrationDesk',
                dataIndex: 'registrationDesk',
                width: 120,
                filters: paymentBalance && paymentBalance.map(x => ({ value: x.value, text: x.label })),
                filterMultiple: false,
                render: (item, record) => {
                    const bgBalance = { background: 'red', color: 'white', padding: '10px' };
                    return (
                        <div style={item && item.balance ? bgBalance : {}}>
                            {/* {item && item.total ? <React.Fragment>Total : {item.total}<br /></React.Fragment> : ''}
                                        {item && item.paid ? <React.Fragment>Paid : {item.paid}<br /></React.Fragment> : ''} */}
                            {item && item.balance !== null && item.balance !== undefined && (
                                <>
                                    Balance : {item.balance}
                                    <br />
                                </>
                            )}

                            {item && item.balance ? <React.Fragment>
                                <Button
                                    className={styles.btn}
                                    onClick={() => this.openPayNow(record)}
                                >Recv Now</Button>
                            </React.Fragment> : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Follow Up',
                key: 'followUp.followUpDate',
                width: 200,
                dataIndex: 'followUp',
                searchDateName: 'followUp.followUpDate',
                render: (text, record) => {
                    return <LatestFollowUp info={text} />
                }
            },
            {
                title: 'Last Updated By',
                width: 150,
                key: 'updatedByUser',
                dataIndex: 'updatedByUser',
                searchTextName: 'updatedByUser',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={common.user}>{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            }
        ]

        if (claimDeskRights && !claimDeskRights.viewByBranch) {

            let dataItem = {
                title: 'Channel Partner',
                key: 'leadSource',
                width: 150,
                dataIndex: 'leadSource',
                filters: channelPartnerList && channelPartnerList.map(x => ({
                    value: x._id,
                    text: x.channelPartnerName
                })),
                render: (text, record) => {
                    let found

                    let channelPartnerId = null;

                    if (record && record.visaDesk) {
                        if (record.visaDesk.channelPartnerId) {
                            channelPartnerId = record.visaDesk.channelPartnerId;
                        } else if (
                            record.visaDesk.selectedCourse &&
                            record.visaDesk.selectedCourse.channelPartnerId
                        ) {
                            channelPartnerId = record.visaDesk.selectedCourse.channelPartnerId;
                        }
                    }
                    // console.log(channelPartnerId);
                    if (channelPartnerId && channelPartnerId != '') {
                        found = _.find(channelPartnerList, (item) => {
                            return item._id === channelPartnerId
                        })
                    }
                    return (<div>
                        <div style={{ color: '#ffa500' }}>{found ? found.channelPartnerName : record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.universityPartnership ? record.visaDesk.selectedCourse.universityPartnership : null}</div>
                    </div>)
                }
            }
            let invoiceStatusCoulmn = {
                title: 'Invoice Status',
                key: 'invoiceStatus',
                width: 140,
                dataIndex: 'invoiceStatus',
                render: (text, record) => {
                    return this.renderStatus(record)
                }
            }
            columns.splice(7, 0, dataItem)
            columns.splice(10, 0, invoiceStatusCoulmn)

        }


        return (

            <PageHeaderWrapper deskColor={deskColor} title={
                <>
                    CLAIM DESK (Students): {this.state.count}
                    <Popover style={{ width: '10px' }} content={content}>
                        <HiInformationCircle
                            style={{ cursor: 'pointer', alignContent: 'right', fontSize: '20px', color: '#ffb703' }}
                        />
                    </Popover>
                </>

            }>

                {statCard}
                {
                    this.state.showMultipleFollowupDrawer ?
                        <MultipleFollowUpDrawer counsellingData={counsellingData} onClose={this.closeMultipleFollowUp} />

                        : null
                }
                {
                    showReviewDrawer ?
                        <InquiryReviewDrawer details={inquiryDetail} onClose={this.closeReviewDrawer} />
                        : null
                }
                {this.state.showFollowUp ? (
                    <ListFollowUps studentObj={studentObj} onClose={this.closeFollowUp} />
                ) : null}
                {
                    this.state.showBranchInvoiceDrawer ?
                        <BranchInvoiceApprovalDrawer onClose={this.closeBranchInvoiceDrawer} />

                        : null
                }
                {
                    showEnrollmentDrawer ?
                        <EnrollmentDrawer onClose={this.closeEnrollmentDrawer} />
                        : null
                }
                {
                    showUploadDetailForm ?
                        <InvoiceUploadForm selectMultipleRecords={selectMultipleRecords} onClose={this.closeUploadCompanyDetails} />
                        : null
                }
                {
                    showCompanyDetailForm ?
                        <CompanyDetails selectMultipleRecords={selectMultipleRecords} enableBTN={enableBTN} onClose={this.closeDocument} onSelect={(e) => this.selectCompanyBankId(e)} />
                        : null
                }

                {
                    showSelectedInvoices ?
                        <SelectedStudentInvoices selectMultipleRecords={selectMultipleRecordsData} onClose={this.closeStudentInvoiceDrawr.bind()} />
                        : null
                }

                {this.state.showPayNow ? (
                    <Payment inquiryObj={inquiryObj} onClose={this.closePayNow} />
                ) : null}
                {this.state.showWhatsAppSms ? (
                    <WhatsAPPSMS counsellingData={counsellingData} onClose={this.closeWhatsSMS} />
                ) : null}

                {this.state.showSMS ? (
                    <SMS counsellingData={counsellingData} onClose={this.closeSMS} />
                ) : null}

                {this.state.showEmail ? (
                    <EmailDrawer counsellingData={counsellingData} onClose={this.closeEmail} />
                ) : null}

                {/* Test Filters Start */}
                <Card
                    style={{ marginBottom: 16, borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}
                    bordered={false}
                >
                    <Row gutter={[24, 16]}> {/* Adds perfect spacing between filter items */}

                        {/* Commission Status */}
                        <Col xs={24} sm={12} md={6}>
                            <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>Commission Status</div>
                            <Select
                                allowClear
                                showSearch
                                style={{ width: '100%' }}
                                value={this.state.commissionStatus}
                                placeholder="Select Status"
                                onChange={commissionStatus => {
                                    this.setState({ commissionStatus }, () => {
                                        setTimeout(() => { this.table.current.reload() }, 500);
                                    });
                                }}
                            >
                                {invoiceStatusList2.map((val, idn) => (
                                    <Option key={idn} value={val}>{val}</Option>
                                ))}
                            </Select>
                        </Col>

                        {/* Term Number */}
                        <Col xs={24} sm={12} md={6}>
                            <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>Term Number</div>
                            <Select
                                allowClear
                                showSearch
                                style={{ width: '100%' }}
                                value={this.state.termNumber}
                                placeholder="Select Term"
                                onChange={termNumber => {
                                    this.setState({ termNumber }, () => {
                                        setTimeout(() => { this.table.current.reload() }, 500);
                                    });
                                }}
                            >
                                {termList.map((val, idn) => (
                                    <Option key={idn} value={val}>{val}</Option>
                                ))}
                            </Select>
                        </Col>

                        {/* Invoice Status */}
                        <Col xs={24} sm={12} md={6}>
                            <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>Invoice Status</div>
                            <Select
                                allowClear
                                showSearch
                                style={{ width: '100%' }}
                                value={this.state.invoiceStatus}
                                placeholder="Select Status"
                                onChange={invoiceStatus => {
                                    this.setState({ invoiceStatus }, () => {
                                        setTimeout(() => { this.table.current.reload() }, 500);
                                    });
                                }}
                            >
                                {invoiceStatuses.map((val, idn) => (
                                    <Option key={idn} value={val}>{val}</Option>
                                ))}
                            </Select>
                        </Col>

                        {/* Year Search */}
                        <Col xs={24} sm={12} md={6}>
                            <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>Invoice Year</div>
                            <Select
                                allowClear
                                showSearch
                                style={{ width: '100%' }}
                                value={this.state.invoiceYear}
                                placeholder="Select Year"
                                onChange={invoiceYear => this.searchByInvoiceYear(invoiceYear)}
                            >
                                {Array.from({ length: 7 }, (_, index) => {
                                    const year = new Date().getFullYear() - index;
                                    return <Option key={year} value={year}>{year}</Option>;
                                })}
                            </Select>
                        </Col>

                        {/* Review Status */}
                        <Col xs={24} sm={12} md={6}>
                            <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>Review Status</div>
                            <Select
                                allowClear
                                showSearch
                                style={{ width: '100%' }}
                                placeholder="Select Review Status"
                                value={this.state.reviewStatus}
                                onChange={(v) => this.setState({ reviewStatus: v }, () => this.table.current.reload())}
                            >
                                {reviewStatusOptions.map((val, idx) => (
                                    <Option key={idx} value={val.value}>{val.text}</Option>
                                ))}
                            </Select>
                        </Col>

                        {/* Invoice Date Range */}
                        <Col xs={24} sm={12} md={6}>
                            <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>Invoice Date Range</div>
                            <RangePicker
                                style={{ width: '100%' }}
                                format="YYYY-MM-DD"
                                placeholder={['Start', 'End']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>

                        {/* University Selection */}
                        <Col xs={24} sm={12} md={6}>
                            <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>University</div>
                            <Select
                                allowClear
                                showSearch
                                optionFilterProp="children"
                                style={{ width: '100%' }}
                                placeholder="Select University"
                                value={universityInstitutionName}
                                onChange={(v) => this.setState({ universityInstitutionName: v }, () => this.table.current.reload())}
                            >
                                {universities.map((val, idn) => (
                                    <Option key={idn} value={val._id}>{val.display}</Option>
                                ))}
                            </Select>
                        </Col>

                        {/* Channel Partner (Conditional) */}
                        {claimDeskRights && !claimDeskRights.viewByBranch && (
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>Channel Partner</div>
                                <Select
                                    allowClear
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="Select Partner"
                                    value={channelPartnerId}
                                    onChange={(v) => this.setState({ channelPartnerId: v }, () => this.table.current.reload())}
                                >
                                    {channelPartners.map((val, idn) => (
                                        <Option key={idn} value={val._id}>{val.display}</Option>
                                    ))}
                                </Select>
                            </Col>
                        )}

                        {/* Intake & Selection Display */}
                        <Col xs={24} sm={12} md={6}>
                            <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>Intake</div>
                            <MonthPicker
                                style={{ width: '100%' }}
                                format="YYYY-MMM"
                                onChange={this.onChangeDatePicker}
                                placeholder="Select Intake"
                            />
                        </Col>

                        <Col xs={24} sm={12} md={6}>
                            <div
                                style={{
                                    marginBottom: 8,
                                    fontWeight: 500,
                                    color: '#1890ff',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}
                            >
                                <span>Selected Intakes</span>

                                {selectedDates.length > 0 && (
                                    <Button
                                        type="link"
                                        size="small"
                                        onClick={this.clearSelectedIntakes}
                                        style={{ padding: 0 }}
                                    >
                                        Clear All
                                    </Button>
                                )}
                            </div>

                            <div
                                style={{
                                    padding: '5px 8px',
                                    background: '#e6f7ff',
                                    borderRadius: '4px',
                                    border: '1px solid #91d5ff',
                                    minHeight: '32px'
                                }}
                            >
                                {selectedDates.length > 0 ? (
                                    selectedDates.map((date, index) => (
                                        <Tag
                                            key={date}
                                            closable
                                            onClose={() => this.removeSelectedIntake(index)}
                                            style={{ marginBottom: 4 }}
                                        >
                                            {date}
                                        </Tag>
                                    ))
                                ) : (
                                    <span style={{ color: '#bfbfbf', fontSize: 12 }}>None</span>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Card>

                {/* Test Filters End */}


                <Card
                    style={{ marginBottom: 16, borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}
                    bodyStyle={{ padding: '12px 20px' }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>

                        {/* Left Side: Filter & Selection */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>

                            <Button.Group>
                                <Button onClick={() => this.selectAllUserFxn()} icon="check-square">
                                    Select Visible
                                </Button>
                                <Button onClick={() => this.unselectAllUserFxn()} icon="border">
                                    Clear
                                </Button>
                            </Button.Group>
                        </div>

                        {/* Right Side: Bulk Actions */}
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>

                            {/* Invoice Actions */}
                            {claimDeskRights && !claimDeskRights.viewByBranch && (
                                <React.Fragment>
                                    <Button
                                        type="primary"
                                        ghost
                                        icon="upload"
                                        onClick={() => this.doUploadMultipleInvoices()}
                                    >
                                        Group Invoice
                                    </Button>
                                    <Button
                                        type="primary"
                                        icon="file-done"
                                        onClick={() => this.doGenerateMultipleInvoices()}
                                    >
                                        Generate Invoice
                                    </Button>
                                    <Button onClick={() => window.open('/finance-desk', '_blank')}>
                                        Invoice List
                                    </Button>
                                </React.Fragment>
                            )}

                            {/* Communication Tools - Using a Dropdown to save space */}
                            <Dropdown
                                overlay={
                                    <Menu>
                                        <Menu.Item key="email" onClick={() => this.showEmail()}>
                                            <Icon type="mail" /> Send E-mail
                                        </Menu.Item>

                                        <Menu.Item key="sms" onClick={() => this.showSMS()}>
                                            <Icon type="message" /> Send SMS
                                        </Menu.Item>

                                        <Menu.Item key="whatsapp" onClick={() => this.showWhatsAppSms()}>
                                            <FaWhatsapp style={{ marginRight: 10 }} />
                                            WhatsApp
                                        </Menu.Item>
                                    </Menu>
                                }
                            >
                                <Button icon="share-alt">
                                    Reach Out <Icon type="down" />
                                </Button>
                            </Dropdown>

                        </div>
                    </div>
                </Card>
                <Card
                    style={{
                        marginBottom: 10,
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                        border: '1px solid #f0f0f0'
                    }}
                    bodyStyle={{ padding: '12px 16px' }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

                        {/* Action Group */}
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                            <Button
                                type="primary"
                                icon="plus-circle"
                                className={styles.btn}
                                onClick={() => this.addMultipleFollowUps()}
                            >
                                Add Multiple Follow-Ups
                            </Button>

                            <Popconfirm
                                title="Are you sure you want to move selected students to the archive desk?"
                                onConfirm={() => this.moveToArchiveDesk()}
                                okText="Yes, Move"
                                cancelText="No"
                                icon={<Icon type="question-circle-o" style={{ color: 'red' }} />}
                            >
                                <Button
                                    icon="file-zip"
                                    className={styles.btn}
                                    style={{ borderColor: '#d9d9d9', color: 'rgba(0, 0, 0, 0.65)' }}
                                >
                                    Move to Archive
                                </Button>
                            </Popconfirm>
                            <RightsWrapper myRight={"financeWalletReport.view"}>
                                <Button
                                    icon="wallet"
                                    className={styles.btn}
                                    style={{ borderColor: '#722ed1', color: '#722ed1', background: '#f9f0ff' }}
                                    onClick={() => window.open('/finance-wallet-report', '_blank')}
                                >
                                    View Wallet Report
                                </Button>
                            </RightsWrapper>
                        </div>

                        {/* Status/Selection Group */}
                        {count > 0 && (
                            <div
                                onClick={this.showSelectedStudentDrawr.bind(this)}
                                style={{
                                    cursor: 'pointer',
                                    background: '#fff7ed', // Light orange background
                                    border: '1px solid #fb8500',
                                    padding: '4px 12px',
                                    borderRadius: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    transition: 'all 0.3s'
                                }}
                                className="selected-counter-hover"
                            >
                                <Badge count={count} style={{ backgroundColor: '#fb8500' }} />
                                <span style={{ color: '#fb8500', fontWeight: 600, fontSize: '13px' }}>
                                    Students Selected
                                </span>
                                <Icon type="right" style={{ color: '#fb8500', fontSize: '12px' }} />
                            </div>
                        )}

                    </div>
                </Card>
                <Card
                    style={{ marginBottom: 15, borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', border: 'none' }}
                    bodyStyle={{ padding: '20px 24px' }}
                >
                    <Row align="middle" type="flex" justify="space-between">
                        {/* SECTION 1: TOTAL INVOICES */}
                        <Col span={5}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div className="stat-icon-wrapper bg-blue" style={{ width: 42, height: 42, fontSize: '20px', marginRight: 12 }}>
                                    <Icon type="file-text" />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ color: '#8c8c8c', fontSize: '11px', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '0.5px' }}>
                                        Total Invoices
                                    </span>
                                    <span style={{ fontSize: '22px', fontWeight: 'bold', color: '#262626', lineHeight: 1 }}>
                                        {invoicesTotal.invoiceTotal || 0}
                                    </span>
                                </div>
                            </div>
                        </Col>

                        {this.state.invoicePrefixes && (
                            <>
                                {/* VERTICAL DIVIDER */}
                                <Col span={1} style={{ textAlign: 'center' }}>
                                    <Divider type="vertical" style={{ height: '40px', backgroundColor: '#e8e8e8' }} />
                                </Col>

                                {/* SECTION 2: PERFORMA */}
                                <Col span={5}>
                                    <div
                                        onClick={() => window.open('/finance-desk-performa', '_blank')}
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            textAlign: 'center',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <span
                                            style={{
                                                color: '#8c8c8c',
                                                fontSize: '11px',
                                                textTransform: 'uppercase',
                                                fontWeight: 600,
                                                marginBottom: 4
                                            }}
                                        >
                                            {this.state.invoicePrefixes.performaInvoiceNumberPrefix}
                                        </span>
                                        <div onClick={() => window.open('/finance-desk-performa', '_blank')}>
                                            <Tag
                                                color="orange"

                                                style={{
                                                    margin: '0 auto',
                                                    borderRadius: '10px',
                                                    fontWeight: 'bold',
                                                    fontSize: '16px',
                                                    padding: '0 12px'
                                                }}
                                            >
                                                {invoicesTotal.performaInvoiceTotal || 0}
                                            </Tag>
                                        </div>
                                    </div>
                                </Col>


                                {/* SECTION 3: FINAL INVOICE */}
                                <Col span={5}>
                                    <div
                                        onClick={() => window.open('/finance-desk', '_blank')}
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            textAlign: 'center',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <span
                                            style={{
                                                color: '#8c8c8c',
                                                fontSize: '11px',
                                                textTransform: 'uppercase',
                                                fontWeight: 600,
                                                marginBottom: 4
                                            }}
                                        >
                                            {this.state.invoicePrefixes.invoiceNumberPrefix}
                                        </span>

                                        <Tag
                                            color="green"
                                            style={{
                                                margin: '0 auto',
                                                borderRadius: '10px',
                                                fontWeight: 'bold',
                                                fontSize: '16px',
                                                padding: '0 12px'
                                            }}
                                        >
                                            {invoicesTotal.finalInvoiceTotal || 0}
                                        </Tag>
                                    </div>
                                </Col>
                            </>
                        )}
                    </Row>
                </Card>

                <Card bordered={true}>
                    <Search id="search-student-input" placeholder="Search Student" onSearch={value => this.changeSearchValue(value)} enterButton />
                    <TableComp
                        columns={columns}
                        ref={this.table}
                        id={'claimDesk'}
                        showSelector={true}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 1400 } }}
                        scroll={{ y: 500 }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>

            </PageHeaderWrapper>

        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ClaimDesk)

